import { Project, getProjectFromURL, getTitleFromProject } from '@dinnisoft/esteio-gestao-common';
import backgroundImage from '@dinnisoft/esteio-gestao-common/assets/imgs/common/bg_grass_leite_landscape.jpg';
import logo_esteio from '@dinnisoft/esteio-gestao-common/assets/imgs/esteio/logo.png';
import logo_familiadoleite from '@dinnisoft/esteio-gestao-common/assets/imgs/familiadoleite/logo.png';
import logo_gestaobov from '@dinnisoft/esteio-gestao-common/assets/imgs/gestaobov/logo.png';
import logo_lactaleite from '@dinnisoft/esteio-gestao-common/assets/imgs/lactaleite/logo.png';
import logo_milkplan from '@dinnisoft/esteio-gestao-common/assets/imgs/milkplan/logo.png';
import logo_serramar from '@dinnisoft/esteio-gestao-common/assets/imgs/serramar/logo.png';
import logo_superpec from '@dinnisoft/esteio-gestao-common/assets/imgs/superpec/logo.png';
import logo_vallesul from '@dinnisoft/esteio-gestao-common/assets/imgs/vallesul/logo.png';
import logo_verdecampo from '@dinnisoft/esteio-gestao-common/assets/imgs/verdecampo/logo.png';
import logo_vigor from '@dinnisoft/esteio-gestao-common/assets/imgs/vigor/logo.png';

export const getSlugFromURL = (): string => {
  return getProjectFromURL(window.document.URL);
};

export function getLogo(project: string) {
  switch (project) {
    case Project.familiadoleite:
      return logo_familiadoleite;
    case Project.gestaobov:
      return logo_gestaobov;
    case Project.lactaleite:
      return logo_lactaleite;
    case Project.milkplan:
      return logo_milkplan;
    case Project.serramar:
      return logo_serramar;
    case Project.superpec:
      return logo_superpec;
    case Project.vallesul:
      return logo_vallesul;
    case Project.verdecampo:
      return logo_verdecampo;
    case Project.vigor:
      return logo_vigor;
    default:
      return logo_esteio;
  }
}

export function getTitle(project: string) {
  return getTitleFromProject(project);
}

export function getBackgroundImage(project: string) {
  return backgroundImage;
}
